import React from "react";
import DialogInOne from "src/components/DialogInOne";
import { useTranslation } from "src/hooks";

interface IProps {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  content: React.ReactNode;
  onConfirm: () => void;
}

const CreateRequestDialog = (props: IProps) => {
  const { isOpen, onClose, title, content, onConfirm } = props;

  const { t } = useTranslation("walletDeploymentRequests");

  const dialogConfig = {
    title: title || t("create_request"),
    self: {
      open: isOpen,
      onClose: onClose,
    },
    content: content,
    onCancel: onClose,
    onConfirm: onConfirm,
  };

  return <DialogInOne {...dialogConfig} maxWidth="md" />;
};

export default CreateRequestDialog;
